import { PageApi } from './api/PageApi';
import apiInstance from './ApiInstance';

const { _updateLogin,_login,_logout ,_generateTocken,_refreshTocken} = PageApi;
const USER = process.env.REACT_APP_USER;
const PASSWORD = process.env.REACT_APP_PASSWORD;

export async function UpdateLogin(accessToken) {
    const data = {
        dt1: accessToken
    };
    return await apiInstance.post(`${_updateLogin}`, data);
}

export async function Login(usuario, contrasena) {

    const data = {
      username: usuario,
      password: contrasena,
    };

    return await apiInstance.post(`${_login}`, data);
  }

export async function logoutuser(usuario) {
    const data = {
      username: usuario
    };

    return await apiInstance.patch(`${_logout}`, data);
  }

  export async function generateTocken() {
    const data = {
      username: USER,
      password: PASSWORD

    };
    return await apiInstance.post(`${_generateTocken}`, data);
  }
  export async function refreshAccessToken() {
    const accessToken = window.localStorage.getItem("accessToken");
    try {
      const data = {
        currentAccessToken: accessToken
      };
      const response = await apiInstance.post(`${_refreshTocken}`, data, {
        refreshToken: session?.refreshToken,
      });
  
      const { session } = response.data;
  
      if (!session?.accessToken) {
        localStorage.removeItem("accessToken");
      }
  
      localStorage.setItem("accessToken", JSON.stringify(session));
  
      return session;
    } catch (error) {
      localStorage.removeItem("accessToken");
    }


  }
  export async function closeseccuio() {
    const accessToken = window.localStorage.getItem("accessToken");
    const data = {
      currentAccessToken: accessToken
    };
    return await apiInstance.post(`${_refreshTocken}`, data);
  }